import { Page, PageRequestParams } from '../../common/queryClient';
import { UseApiQueryOptions } from '../../common/queryClient/createApiQueryHook';
import { useSystemClassifierItems } from '../../configuration';
import { ProcessingEventDirectoryEntryType } from '../../processingEvent/schema/types';
import {
  useOutputProcessingEventsQuery,
  ProcessingEventsFilter,
  ProcessingEventsFilterKey,
  processingEventsFilterKeys,
} from '../../processingEvent';

export const OUTPUT_DATA_EVENT_LEVEL_CODES = ['ERROR', 'INFO'];
export const OUTPUT_DATA_PROCESSING_TYPE_CODES = [
  'CALCULATE',
  'VALIDATE',
  'CALCULATE_VALIDATE',
];

const processingEventsFilterKeysToExclude = [
  'dataObjectId',
  'dataObjectGroupId',
  'dataObjectType',
  'permissionToManage',
] as const;

type ProcessingEventsFilterKeyToExclude =
  (typeof processingEventsFilterKeysToExclude)[number];

export const outputProcessingEventsFilterKeys =
  processingEventsFilterKeys.filter(
    (
      key,
    ): key is Exclude<
      ProcessingEventsFilterKey,
      ProcessingEventsFilterKeyToExclude
    > =>
      !processingEventsFilterKeysToExclude.includes(
        key as ProcessingEventsFilterKeyToExclude,
      ),
  );

export type OutputProcessingEventsFilter = Omit<
  ProcessingEventsFilter,
  ProcessingEventsFilterKeyToExclude
>;

export type OutputProcessingEventsFilterKey =
  (typeof outputProcessingEventsFilterKeys)[number];

export const useOutputDataProcessingEventsQuery = (
  params: Partial<OutputProcessingEventsFilter> & PageRequestParams,
  options: Partial<
    UseApiQueryOptions<Page<ProcessingEventDirectoryEntryType>>
  > = {},
  refetch?: boolean,
) => {
  const errorLevelId = useSystemClassifierItems(
    'PROCESSING_ERROR_LEVEL',
    OUTPUT_DATA_EVENT_LEVEL_CODES,
  ).map(({ id }) => id);

  return useOutputProcessingEventsQuery(
    {
      ...params,
      refetch,
      errorLevelId: params.errorLevelId?.length
        ? params.errorLevelId
        : errorLevelId,
    },
    options,
  );
};
